import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=0bf5fad0&scoped=true&"
import script from "./DownloadBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadBtn.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DownloadBtn.vue?vue&type=style&index=1&id=0bf5fad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5fad0",
  null
  
)

export default component.exports